











import ModalReset from "@/components/modals/ModalReset.vue";
import { eventBus, IModalPayload } from "@/lib/event-bus";
import { Component, Vue } from "vue-property-decorator";

/**
 * A parent modal component used to display various modal windows.
 */
@Component({
  components: { ModalReset }
})
export default class Modal extends Vue {
  private isOpen: boolean = false;
  private modalComponent: string = "";

  /**
   * Apply or remove blur filter on elements with the View class.
   */
  private blurView(blur: boolean = true): void {
    const viewElement = document.querySelector(".View") as HTMLElement;
    if (!viewElement) return;
    if (blur) {
      viewElement.style.filter = "blur(6px)";
    } else {
      viewElement.style.filter = "";
    }
  }

  private handleModalClose(): void {
    this.isOpen = false;
    this.blurView(false);
  }

  private mounted(): void {
    eventBus.$on("modal:close", () => {
      this.handleModalClose();
    });
    eventBus.$on("modal:open", (payload: IModalPayload) => {
      this.isOpen = true;
      this.modalComponent = payload.component;
      this.blurView();
    });
  }
}
